// used to trigger e.g. clean event on native inputs or selects
export var triggerChangeEvent = function triggerChangeEvent(ref, currentValue, newValue) {
  var event = new Event('change', {
    // @ts-expect-error expected set of props
    detail: {
      oldValue: currentValue,
      newValue: newValue
    },
    bubbles: true,
    cancelable: true
  }); // @ts-expect-error expected set of prop

  event.simulated = true;
  var tracker = ref._valueTracker;

  if (tracker) {
    tracker.setValue(newValue);
  }

  ref.value = newValue;
  ref.dispatchEvent(event);
};